// extracted by mini-css-extract-plugin
export var closeButton = "_nt-2";
export var closeButtonIcon = "_nt-3";
export var lightboxContent = "_nt-1";
export var lightboxOverlay = "_nt-0";